import React from "react";
import "./styles/LineMaxWidth.css";

export default function LineMaxWidth() {
  return <div className="line-max-width"></div>;
}
